<template>
  <v-dialog :value="value" persistent max-width="800" scrollable>
    <v-card>
      <div class="text-xs-right">
        <v-btn fab flat small @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text style="max-height: 600px">
        <v-layout wrap>
          <template v-for="page in exportpagecount">
            <v-flex xs6 sm4 md3 :key="`expor_${page}`" class="pa-2">
              <div class="z-border-red text-xs-center py-3">
                <v-icon x-large>folder_shared</v-icon>
                <div class="caption">
                  {{ ((page - 1) * exportlimit + 1) | numberFormat }} -
                  <template v-if="page == exportpagecount">
                    {{ total | numberFormat }}
                  </template>
                  <template v-else>{{ (page * exportlimit) | numberFormat }}</template>
                </div>

                <v-btn small color="primary" depressed @click="handleExportByPage(page)">
                  download
                </v-btn>
              </div>
            </v-flex>
          </template>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'exportpagecount', 'exportlimit', 'total'],
  data() {
    return {
      exportpagecount: 0
    }
  },
  methods: {
    handleExportByPage(page) {
      this.$emit('handleExportByPage', page)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/ExportList.vue